import React from "react";
import ReactDOM from "react-dom";
import TagManager from "react-gtm-module";
import "./i18n";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./css/style.css";
import "./css/responsive.css";
import "./css/landingStyle.css";
import "./css/landingResponsive.css";

const tagManagerArgs = {
  gtmId: "GTM-K98K7F9",
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
